/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 11:29:05
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-29 11:36:23
 * @FilePath: /unifyxp-v2-store-portal/src/request/storeSettings/invoice.ts
 */
import { get, post } from 'src/tools/server';

export const getInvoiceSetting = () => {
  return get<any>('/portal/setting/store/invoice', {});
};

export const saveInvoiceSetting = (data) => {
  return post<any>('/portal/setting/store/invoice', data, {});
};
